module.exports = "/img/_/_/_/assets/images/creeper/battle/common//45.jpg?fcbce640d14152e6061c5276704f4431";